import React from 'react'
import PropTypes from 'prop-types'
import Link from 'gatsby-link'
import { FormattedMessage } from 'react-intl'
let key = 'FR'
const SelectLanguage = props => {
  const path = props.pathname.split('/')[1]
  const langPath = path == 'en-CA' || 'fr-CA' ? path : 'en-CA'

  const links = props.langs.map(lang => {
    return lang.langKey != langPath ? (
      <Link
        to={lang.link}
        key={lang.langKey}
        style={{
          color: 'white',
        }}
      >
        <li selected={lang.selected}>{lang.langKey}</li>
      </Link>
    ) : null
  })

  return (
    <section>
      <header
        style={{
          color: 'white',
        }}
      >
        {/* <FormattedMessage id="selectLanguage" /> */}
      </header>
      <ul>{links}</ul>
    </section>
  )
}

SelectLanguage.propTypes = {
  langs: PropTypes.array,
}

export default SelectLanguage
